import { gql } from '@apollo/client';
import { FRAGMENT_MONITOR } from './fragment.monitor';
import { FRAGMENT_SOURCE_AREA_PROCESS } from './fragment.sourceAreaProcess';

export const FETCH_PROCESSES = gql`
    ${FRAGMENT_SOURCE_AREA_PROCESS}
    ${FRAGMENT_MONITOR}
    query fetchProcesses($filter: ProcessFilter!) {
        facility {
            databaseId
            processes(filter: $filter) {
                id
                name
                type
                description
                processClass
                omnisConfigJson
                omnisLocationId
                retentionInDays
                credentials {
                    id
                    apiKey
                    description
                    deactivatedTime
                    lastUsedTime
                    generatedTime
                    credentialProcess {
                        id
                        processId
                        facilityDatabaseId
                        requiresSecureConnection
                        deviceSerialNumber
                    }
                    accessControls {
                        key
                        isAllowed
                    }
                }
                ...sourceAreaProcess
                ...monitor
                ...noiseMonitor
                ...discreteReceptor
            }
        }
    }
`;
